<template>
  <div class="whitening-process">
    <table v-if="table" aria-label="Whitening Process">
      <thead><tr><th v-for="(label, index) in table.headers" :key="index" scope="col">{{ label }}</th></tr></thead>
      <tbody><tr v-for="(row, index) in table.rows" :key="index"><td v-for="(cell, column) in row" :key="column">{{ cell }}</td></tr></tbody>
    </table>
    <rich-text :field="table ? followingText : field" />
  </div>
</template>
<script>
import RichText from '@/components/RichText'
export default {
  name: 'ProductWhiteningProcess',
  components: { RichText },
  props: { field: { type: Array, required: true } },
  computed: {
    table () {
      const lines = String(this.field[0]?.text || '').split('\n').map(line => line.split('\t'))
      if (lines.length < 2 || lines[0].length !== 2 || lines[0][0] !== 'Action' || lines[0][1] !== 'Ingredient' || lines.slice(1).some(row => row.length !== 2 || row.some(cell => !cell.trim()))) return null
      return { headers: lines[0], rows: lines.slice(1) }
    },
    followingText () { return this.field.slice(1) }
  }
}
</script>
<style scoped>
.whitening-process { width: 100%; max-width: 100%; font: inherit; letter-spacing: inherit; }
.whitening-process table { width: 100%; margin: 0 0 1.5em; border-collapse: collapse; table-layout: fixed; text-align: left; font: inherit; }
.whitening-process th, .whitening-process td { width: 50%; padding: 0; vertical-align: top; overflow-wrap: break-word; }
.whitening-process th:first-child, .whitening-process td:first-child { padding-right: 1.5em; }
.whitening-process th { font-weight: bold; }
</style>
